/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleFactOwnershipTransitionAuditData
 */
export interface GoogleFactOwnershipTransitionAuditData {
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    factFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    providerAccountKey?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    previousSource?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    previousIntegrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    nextSource?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    nextIntegrationId?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    changedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    rolledBackEffectiveFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GoogleFactOwnershipTransitionAuditData
     */
    rolledBackAt?: Date | null;
}

/**
 * Check if a given object implements the GoogleFactOwnershipTransitionAuditData interface.
 */
export function instanceOfGoogleFactOwnershipTransitionAuditData(value: object): value is GoogleFactOwnershipTransitionAuditData {
    return true;
}

export function GoogleFactOwnershipTransitionAuditDataFromJSON(json: any): GoogleFactOwnershipTransitionAuditData {
    return GoogleFactOwnershipTransitionAuditDataFromJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionAuditDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFactOwnershipTransitionAuditData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'factFamily': json['factFamily'] == null ? undefined : json['factFamily'],
        'providerAccountKey': json['providerAccountKey'] == null ? undefined : json['providerAccountKey'],
        'previousSource': json['previousSource'] == null ? undefined : json['previousSource'],
        'previousIntegrationId': json['previousIntegrationId'] == null ? undefined : json['previousIntegrationId'],
        'nextSource': json['nextSource'] == null ? undefined : json['nextSource'],
        'nextIntegrationId': json['nextIntegrationId'] == null ? undefined : json['nextIntegrationId'],
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'changedAt': json['changedAt'] == null ? undefined : (new Date(json['changedAt'])),
        'rolledBackEffectiveFrom': json['rolledBackEffectiveFrom'] === undefined ? undefined : json['rolledBackEffectiveFrom'] === null ? null : (new Date(json['rolledBackEffectiveFrom'])),
        'rolledBackAt': json['rolledBackAt'] === undefined ? undefined : json['rolledBackAt'] === null ? null : (new Date(json['rolledBackAt'])),
    };
}

export function GoogleFactOwnershipTransitionAuditDataToJSON(json: any): GoogleFactOwnershipTransitionAuditData {
    return GoogleFactOwnershipTransitionAuditDataToJSONTyped(json, false);
}

export function GoogleFactOwnershipTransitionAuditDataToJSONTyped(value?: GoogleFactOwnershipTransitionAuditData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'factFamily': value['factFamily'],
        'providerAccountKey': value['providerAccountKey'],
        'previousSource': value['previousSource'],
        'previousIntegrationId': value['previousIntegrationId'],
        'nextSource': value['nextSource'],
        'nextIntegrationId': value['nextIntegrationId'],
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'reason': value['reason'],
        'changedAt': value['changedAt'] == null ? value['changedAt'] : value['changedAt'].toISOString(),
        'rolledBackEffectiveFrom': value['rolledBackEffectiveFrom'] == null ? value['rolledBackEffectiveFrom'] : value['rolledBackEffectiveFrom'].toISOString().substring(0,10),
        'rolledBackAt': value['rolledBackAt'] == null ? value['rolledBackAt'] : value['rolledBackAt'].toISOString(),
    };
}

